<template>
    <b-col md="12" sm="8">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <b-form v-on:submit.prevent="onSubmit">
            <h1>Editar Usuário</h1>
            <b-row>
              <b-col cols="4">
                <b-form-group label="CPF:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-mask="'###.###.###-##'"
                                  type="text"
                                  class="form-control"
                                  placeholder="CPF"
                                  autocomplete="cpf"
                                  v-model="$v.form.cpf.$model"
                                  :state="chkState('cpf')"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback1">CPF é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <b-form-group label="Nome:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model.trim="$v.form.nome.$model"
                                  :state="chkState('nome')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group label="E-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  v-model.trim="$v.form.email.$model"
                                  :state="chkState('email')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Confirme o e-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  id="confirmar-email"
                                  placeholder="Confirme o e-mail"
                                  oncut="return false"
                                  onpaste="return false"
                                  autocomplete="confirme-email"
                                  v-model.trim="$v.form.confirmaEmail.$model"
                                  :state="chkState('confirmaEmail')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback8">Este é um campo obrigatório, e deve ser correspondente ao campo e-mail.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group label="Tipo de Usuário:">
                  <b-form-select v-model.trim="$v.form.tipoUsuario.$model" :state="chkState('tipoUsuario')"
                                 placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in perfis" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                  <b-form-group label="UF: *" :state="chkState('uf')" invalid-feedback='UF é obrigatório.'>
                    <multiselect
                      v-model="$v.form.uf.$model"
                      :options="estados"
                      label="sigla"
                      track-by="id"
                      placeholder="Selecione"
                      selectLabel="" deselectLabel="" selectedLabel=""
                      :tagglabe="true"
                      :multiple="true"
                      :max="1"
                      :state="chkState('uf')">
                        <span slot="maxElements"></span>
                        <span slot="noResult">Nenhum encontrado</span>
                        <span slot="noOptions">Lista vazia</span>
                      </multiselect>
                  </b-form-group>
                </b-col>
            </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-row>
            <b-col v-if="!loading" md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
                <i class="fa fa-pencil"></i>&nbsp;
                <span>Alterar Usuário</span>
              </b-button>
            </b-col>
            <b-col v-else md="3">
              <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
                <b-spinner small type="grow"></b-spinner>Salvando...
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/usuarios')">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, minLength, email, sameAs} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      cpf: {
        required,
        minLength: minLength(14)
      },
      nome: {
        required
      },
      email: {
        required,
        email
      },
      confirmaEmail: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      tipoUsuario: {
        required
      },
      uf: {
        required
      }
    }
  },
  created () {
    this.$store.dispatch('buscarEstadosPorRegiao')
    this.$store.dispatch('getPerfis')
  },
  data () {
    return {
      loading: false,
      form: {
        id: '',
        cpf: '',
        tipoUsuario: null,
        nome: '',
        email: '',
        uf: null,
        confirmaEmail: ''
      },
      disabled_cidades: true,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false,
      todas_cidades: false
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    perfis () {
      return this.$store.state.perfil.lista
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  mounted () {
    this.loadUser(this.$route.params.id)
  },
  methods: {
    loadUser (id) {
      Vue.http.get('api/usuario/' + id).then(response => {
        let data = response.body.data[0]

        this.form.id = data.id
        if (data.estado) {
          this.form.uf = [{
            'id': data.estado.id,
            'sigla': data.estado.sigla
          }]
        } else if (data.cidade) {
          this.form.uf = [{
            'id': data.cidade.estado.id,
            'sigla': data.cidade.estado.sigla
          }]
        }

        this.form.cpf = data.cpf
        this.form.nome = data.nome
        this.form.email = data.email
        this.form.confirmaEmail = data.email
        this.form.tipoUsuario = data.perfil_id
      })
    },
    salvar () {
      let form = this.$v.form
      let data = {
        cpf: form.cpf.$model.replace(/[^\d]+/g, ''),
        estado_id: form.uf.$model[0].id,
        nome: form.nome.$model,
        email: form.email.$model,
        email_confirmation: form.confirmaEmail.$model,
        perfis: JSON.stringify([{ id: form.tipoUsuario.$model }])
      }

      this.loading = true
      Vue.http.put('api/usuario/' + this.form.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/usuarios'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/UsuarioEditar.vue